import { Link } from "react-router-dom";
import IconFA from "../../../../components/icon/icon";
import { useCustomerContext } from "../../../../utils/customerContext";
import { useEffect, useState } from "react";
import Button from "../../../../components/button/button";
import Label from "../../../../components/label/label";
import Input from "../../../../components/input/input";
import CustomSelect from "../../../../components/customSelect/customSelect";
import { useNavigate } from "react-router-dom"
import { useSettings } from "../../../../hooks/useSettings";

function CuDeCustomer({ id }) {
    const { fetchCustomerSlug, customerSlug, deleteCustomer, editCustomer } = useCustomerContext();
    const navigate = useNavigate();
    const [edit, setEdit] = useState(false);
    const { data, fetchData } = useSettings();

    const titles = ['Herr', 'Frau', 'Divers', 'Keine Angabe'];
    const statuses = data?.customerStatusList || ['Statusliste konnte nicht geladen werden. Bitte überprüfe die Einstellungen.'];

    const [editData, setEditData] = useState({
        title: "",
        prename: "",
        name: "",
        phone: "",
        mail: "",
        address: "",
        postCode: "",
        town: "",
        status: ""
    });

    const [selectedStatus, setSelectedStatus] = useState(null);
    const [selectedTitle, setSelectedTitle] = useState(null);

    useEffect(() => {
        fetchCustomerSlug(id);
        fetchData();
    }, [id, fetchCustomerSlug]);

    useEffect(() => {
        if (!edit && customerSlug) {
            setEditData({
                title: customerSlug.title || "",
                prename: customerSlug.prename || "",
                name: customerSlug.name || "",
                phone: customerSlug.phone || "",
                mail: customerSlug.mail || "",
                address: customerSlug.address || "",
                postCode: customerSlug.postCode || "",
                town: customerSlug.town || "",
                status: customerSlug.status || ""
            });
            setSelectedTitle(customerSlug.title ? { id: customerSlug.title, name: customerSlug.title } : null);
            setSelectedStatus(customerSlug.status ? { id: customerSlug.status, name: customerSlug.status } : null);
        }
    }, [customerSlug, edit]);

    const handleDelete = () => {
        deleteCustomer(customerSlug._id, customerSlug.prename, customerSlug.name);
        navigate('/dashboard/customer');
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setEditData(prev => ({ ...prev, [name]: value }));
    };

    const handleEdit = async () => {
        await editCustomer(
            { ...editData, title: selectedTitle?.name || "", status: selectedStatus?.name || "" },
            customerSlug._id,
            id
        );
        setEdit(false);
    };

    return (
        <>
            <div className="cudeHeader">
                <Link to='/dashboard/customer'><IconFA iconName='arrowLeft' /></Link>
                <h1>Kundenübersicht: {customerSlug.prename} {customerSlug.name}</h1>
            </div>

            {!edit && (
                <div className="cudeContentContainer">
                    <div className="cudeHeadingContainer"><h3>Kundendaten</h3></div>
                    <p><strong>Anrede:</strong> {customerSlug.title || 'Keine Angabe'}</p>
                    <p><strong>Vorname:</strong> {customerSlug.prename}</p>
                    <p><strong>Nachname:</strong> {customerSlug.name}</p>
                    <p><strong>Telefon:</strong> {customerSlug.phone || 'Keine Angabe'}</p>
                    <p><strong>E-Mail:</strong> {customerSlug.mail || 'Keine Angabe'}</p>
                    <p><strong>Adresse:</strong> {customerSlug.address}</p>
                    <p><strong>PLZ:</strong> {customerSlug.postCode}</p>
                    <p><strong>Stadt:</strong> {customerSlug.town}</p>
                    <p><strong>Kundennummer:</strong> {customerSlug.customerNumber}</p>
                    <p><strong>Status:</strong> {customerSlug.status || 'Noch nicht angegeben'}</p>
                    <Button buttonValue="Kunde bearbeiten" onClick={() => setEdit(true)} />
                    <Button buttonValue="Kunde löschen" onClick={handleDelete} />
                </div>
            )}

            {edit && (
                <div className="cudeContentContainer">
                    <div className="cudeHeadingContainer"><h3>Kundendaten bearbeiten</h3></div>

                    <Label labelValue='Anrede: ' labelFor='title' />
                    <CustomSelect
                        items={titles.map(t => ({ id: t, name: t }))}
                        selected={selectedTitle}
                        setSelected={setSelectedTitle}
                        placeholder="Anrede wählen"
                        search={false}
                    /><br />

                    <Label labelValue='Vorname: ' labelFor='prename' />
                    <Input
                        type="text"
                        borderColor="#15283B"
                        inputName="prename"
                        inputValue={editData.prename}
                        onChange={handleInputChange}
                        name="prename"
                    /><br />

                    <Label labelValue='Nachname: ' labelFor='name' />
                    <Input
                        type="text"
                        borderColor="#15283B"
                        inputName="name"
                        inputValue={editData.name}
                        onChange={handleInputChange}
                        name="name"
                    /><br />

                    <Label labelValue='Telefon: ' labelFor='phone' />
                    <Input
                        type="number"
                        borderColor="#15283B"
                        inputName="phone"
                        inputValue={editData.phone}
                        onChange={handleInputChange}
                        name="phone"
                    /><br />

                    <Label labelValue='E-Mail: ' labelFor='mail' />
                    <Input
                        type="email"
                        borderColor="#15283B"
                        inputName="mail"
                        inputValue={editData.mail}
                        onChange={handleInputChange}
                        name="mail"
                    /><br />

                    <Label labelValue='Adresse: ' labelFor='address' />
                    <Input
                        type="text"
                        borderColor="#15283B"
                        inputName="address"
                        inputValue={editData.address}
                        onChange={handleInputChange}
                        name="address"
                    /><br />

                    <Label labelValue='PLZ: ' labelFor='postCode' />
                    <Input
                        type="text"
                        borderColor="#15283B"
                        inputName="postCode"
                        inputValue={editData.postCode}
                        onChange={handleInputChange}
                        name="postCode"
                    /><br />

                    <Label labelValue='Stadt: ' labelFor='town' />
                    <Input
                        type="text"
                        borderColor="#15283B"
                        inputName="town"
                        inputValue={editData.town}
                        onChange={handleInputChange}
                        name="town"
                    /><br />

                    <Label labelValue='Status: ' labelFor='status' />
                    <CustomSelect
                        items={statuses.map(s => ({ id: s, name: s }))}
                        selected={selectedStatus}
                        setSelected={setSelectedStatus}
                        placeholder="Status wählen"
                        search={false}
                    /><br />

                    <Button buttonValue='Abbrechen' onClick={() => setEdit(false)} />
                    <Button buttonValue='Speichern' onClick={handleEdit} />
                </div>
            )}
        </>
    );
}

export default CuDeCustomer;